import { useDeviceStore } from '@modules/phone/store/device.store';
import { getProvider } from '@/lib/callProviders/provider-registry';
import { useSwitchCallStore } from '../store/use-switch-call.store';
import { DevicePlatformEnum, useAgentInProgressConversationQuery } from '@/types/generated/graphql';
import { useProfile } from '@components/profile-dropdown/hooks/use-profile-dropdown';

export const useShowSwitchCall = () => {
  const { showSwitchCall, agent } = useSwitchCallStore();

  /**
   * When reloading app, we can
   * check if there is an active call which can be switched
   */
  useAgentInProgressConversationQuery({
    onCompleted: (res) => {
      const data = res?.agentInProgressConversation?.data;

      useSwitchCallStore.setState({
        callId: data?.id,
        showSwitchCall: true,
        agent: {
          /**
           * callPlatform in response has string type
           * This needs to be communicated to backend
           */
          callPlatform: data?.callEntity?.callPlatform as DevicePlatformEnum,
          user: {
            id: loggedInUserId,
          },
        },
      });
    },
  });
  const { call } = useDeviceStore();
  const provider = call ? getProvider(call.provider) : undefined;
  const { loggedInUserId } = useProfile();

  const supervisionMode = call && provider?.getCustomParam(call, 'supervisionMode');
  const supervisionId = call && provider?.getCustomParam(call, 'supervisionId');
  const isSameUser = agent?.user?.id === loggedInUserId;
  const isCallInMobilePlatform = agent?.callPlatform == DevicePlatformEnum.mobile;

  const shouldHideSwitchCall = supervisionMode === 'switch' && supervisionId; // hide banner during call
  const shouldShowSwitchCall = showSwitchCall && isCallInMobilePlatform && isSameUser && !shouldHideSwitchCall;
  return {
    shouldShowSwitchCall,
  };
};
